import { render, staticRenderFns } from "./candidate-resume.vue?vue&type=template&id=b6c6a1da"
import script from "./candidate-resume.vue?vue&type=script&lang=js"
export * from "./candidate-resume.vue?vue&type=script&lang=js"
import style0 from "./candidate-resume.vue?vue&type=style&index=0&id=b6c6a1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports